export default {
  cardPayment: {
    name: 'Nom affiché sur la carte',
    cardNumber: 'Numéro de carte',
    cvc: 'CVC (3 chiffres)',
    expiration: 'Expire le',
    placeholder: {
      name: '@:utils.cardPayment.name',
    },
    errors: {
      cardNumberError: 'Numéro requis',
      cardCvcError: 'CVC requis',
      cardExpiryError: 'Date requise',
      secureError: 'Votre carte nécessite une autorisation 3D Secure obligatoire. Malheureusement ce moyen de paiement n\'est pas encore disponible. Veuillez entrer une autre carte bancaire ou bien choisir un autre moyen de paiement.',
    },
  },
};
